import { Axios } from 'utils'

// TODO: share the logic, probably we don't need downloadMediaFiles
export const useMediaService = () => {
  const downloadMediaFiles = async (link: string) => {
    if (!link) return ''

    const queryString = link?.split('?')[1]
    const params = new URLSearchParams(queryString)

    const path = params?.get('path')
    // TODO: revise with BE
    if (!path) return ''
    const parsedPath = path?.endsWith('=') ? path?.slice(0, -1) : path

    const dest = params?.get('dest')
    if (!dest) return ''

    const response = await Axios.get(`/media`, {
      responseType: 'arraybuffer',
      params: { path: parsedPath, dest },
    })

    if (!response?.data) {
      return ''
    }

    const blob = new Blob([response.data])

    return new File([blob], path)
  }

  const downloadMediaFileSrc = async (link: string) => {
    if (!link) return ''

    const queryString = link?.split('?')[1]
    const params = new URLSearchParams(queryString)

    const path = params?.get('path')
    // TODO: revise with BE
    if (!path) return ''
    const parsedPath = path?.endsWith('=') ? path.slice(0, -1) : path

    const dest = params?.get('dest')

    if (!dest) return ''
    const response = await Axios.get(`/media`, {
      responseType: 'arraybuffer',
      params: { path: parsedPath, dest },
    })

    const blob = new Blob([response.data])

    return URL.createObjectURL(blob)
  }

  return {
    downloadMediaFiles,
    downloadMediaFileSrc,
  }
}
